<script setup>
import {computed, defineEmits, defineProps, onMounted, ref, watch} from "vue";
import {couponConf} from "@/utils/config";
import store from "@/store";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["beiguo-xmair"];
    }
  }
});
const coupon = computed(() => {
  return props.couponLst?.[0]?.data || []
})
const order_from = computed(() => store.state.orderFrom)
const emit = defineEmits(['login'])
const showPayLoading = ref(false)
const product = ref(coupon.value?.[0] || {})
watch(() => props.account, to => {
  if (Object.keys(to).length && Object.keys(product.value).length) {
    showPayLoading.value = true
  }
})
const maxNumber = computed(() => {
  if (Object.keys(props.account).length < 1) return 1;
  return Math.floor(parseFloat(props.account.balance_miles) / parseFloat(coupon.value?.[0]?.score_data?.[props.type.login]?.total))
})
const num = ref(1)
const mobile = ref("")
const loading = ref(false)
const recharge_tools = require("@/assets/images/beiguo/recharge-title.png")
// const rechargeTab = ref("recharge")
// const sendSms = ref(false)
// const realname = ref(false)
onMounted(() => {
  store.commit("getOrderFrom")
})
const payment = () => {
  if (!/^1[3-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("手机号填写错误")
  }
  // if (!sendSms.value) {
  //   sendSms.value = true
  //   return;
  // }
  // sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: product.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: num.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    },
    score_type: props.type.login
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    }
    if (props.type.login !== 'xm_air')
      router.push({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <div class="bg-product-box">
    <div class="bg-product-title">
      <el-image src="https://images.jifen360.com/beiguo/recharge.png"/>
    </div>
    <div class="bg-product-items">
      <div class="bg-product-item" v-for="(item,index) in coupon" :key="index">
        <div class="bg-product-item-prices">
          <div class="bg-product-item-prices-money">
            <b class="bg-product-unit">￥</b>
            <b>{{ parseFloat(item.face_value) }}</b>
          </div>
          <div class="bg-product-logo">
            <el-image src="https://images.jifen360.com/beiguo/logo.png"/>
          </div>
        </div>
        <div class="bg-product-item-content">
          <b class="bg-product-item-content-title">{{ item.name }}</b>
          <div class="bg-product-item-content-btn">
            <div class="bg-product-item-content-btn-left">
              <el-text :type="type?.login === 'xm_air'?'primary':'danger'">
                {{ item?.score_data?.[type?.login]?.total }}
              </el-text>
              <el-text type="info" class="bg-product-unit">
                {{ item?.score_data?.[type?.login]?.unit }}
              </el-text>
            </div>
            <div class="bg-product-item-content-btn-right">
              <el-button round type="danger" v-if="Object.keys(account).length < 1"
                         @click="product = item,emit('login')">
                立即兑换
              </el-button>
              <el-button round type="danger"
                         v-else-if="account && account.balance_miles >= parseInt(item?.score_data?.[type.login]?.total)"
                         @click="product=item,showPayLoading=true">
                立即兑换
              </el-button>
              <el-button round type="info" v-else>可用{{ item?.score_data?.[type.login]?.unit }}不足</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-recharge-box">
    <div>
      <el-image :src="recharge_tools"/>
    </div>
    <div class="bg-recharge-content">
      <ol class="bg-recharge-content-item">
        <li>积分兑换商品不提供报销凭证，一经兑换不可退换、转售、兑现、找零、拆分使用，不可转赠给他人使用；</li>
        <li>
          本代金券为卡密产品，兑换时请填写正确的收货手机号，请确保手机号填写正确，因手机号码填写错误造成的损失由会员本人承担；
        </li>
        <li>如遇产品不能正常兑换或使用，请拨打客服热线:4000-360-195。</li>
      </ol>
      <b>使用说明</b>
      <ol class="bg-recharge-content-item">
        <li>适用门店:适用于石家庄市区北国超市线下门店消费使用，门店地址及联系电话请
          <el-link type="danger" @click="router.push({name:'store'})">点击查看</el-link>
          ；
        </li>
        <li>有效期:自兑换成功之日起90天内有效，请在有效期内使用，过期自动作废；</li>
        <li>使用方法：到北国超市收银台结款时，出示代金券券码验证使用；</li>
        <li>
          使用规则:本代金券为一次性使用券，代金券为无门槛使用，可叠加多张同时使用，不找零不折现，不与店内其他优惠同享。除自收银、大宗团购、特例商品外全场通收，特例商品详见各门店明示；
        </li>
        <li>本平台仅是提供会员与商户之间的兑换服务平台，如遇商品质量问题，请及时与商户联系。</li>
      </ol>
    </div>
  </div>
  <el-drawer direction="btt" v-model="showPayLoading" :with-header="false" class="product-drawer" size="440"
             @closed="product={},mobile='',num=1" style="background-color: #FAFAFA">
    <div class="bg-product-info-title">
      <div class="bg-product-info-title-price">
        <div class="bg-product-top">
          <b class="bg-product-unit">￥</b>
          <b class="bg-product-money">{{ parseFloat(product?.face_value) }}</b>
        </div>
        <div class="bg-product-bottom">
          石家庄市区门店通用
        </div>
      </div>
      <div class="bg-product-info-content">
        <b class="bg-product-info-content-title">{{ product?.name }}</b>
        <div class="bg-product-item-content-btn-left">
          <el-text :type="type.login === 'xm_air'?'primary':'danger'">
            {{ product?.score_data?.[type.login]?.total }}
          </el-text>
          <el-text type="info" class="bg-product-unit">
            {{ product?.score_data?.[type.login]?.unit }}
          </el-text>
        </div>
      </div>
    </div>
    <el-card shadow="never">
      <div class="bg-product-form-item">
        <div class="bg-product-form-label">收货手机号</div>
        <div class="bg-product-form-input">
          <el-input placeholder="请输入收货手机号" v-model="mobile"/>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="bg-product-form-item">
        <div class="bg-product-form-label">兑换数量</div>
        <div class="bg-product-form-input">
          <el-input-number v-model="num" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="bg-product-form-item">
        <div class="bg-product-form-label">可用{{ product?.score_data?.[type.login]?.unit }}</div>
        <div class="bg-product-form-input">
          {{ account?.balance_miles || 0 }}
        </div>
      </div>
      <div class="bg-product-form-item">
        <div class="bg-product-form-label">支付{{ product?.score_data?.[type.login]?.unit }}</div>
        <div class="bg-product-form-input">
          {{ product?.score_data?.[type?.login]?.total * num || 0 }}
        </div>
      </div>
    </el-card>

    <el-button round :type="type.login === 'xm_air'?'primary':'danger'" style="width: 100%" size="large"
               :loading="loading" @click="payment">
      立即兑换
    </el-button>
  </el-drawer>
</template>

<style scoped lang="less">
.bg-product-box {
  margin: 15px;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;

  .bg-product-title {
    box-sizing: border-box;
    padding: 10px 0;
    //渐变色
    background: linear-gradient(to bottom, #EE8178 0%, #ffffff 100%);
  }

  .bg-product-items {
    box-sizing: border-box;
    padding: 10px;
    margin-top: -10px;

    .bg-product-item {
      background: url("@/assets/images/beiguo/coupon.png") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 10px;

      .bg-product-item-prices {
        flex-basis: 25%;
        width: 25%;
        margin-right: 10px;
        text-align: center;

        .bg-product-item-prices-money {
          font-size: 1.7rem;
          display: flex;
          justify-content: center;
          color: #CF392E;

          .bg-product-unit {
            font-size: .8rem;
          }
        }

        .bg-product-logo {
          margin-top: 10px;

          .el-image {
            width: 80%;
          }
        }
      }

      .bg-product-item-content {
        flex-basis: 75%;
        width: 75%;
        line-height: 1.7;
        padding: 0 10px;
        box-sizing: border-box;

        .bg-product-item-content-title {
          font-size: .85rem;
        }

        .bg-product-item-content-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }
}

.bg-recharge-box {
  margin: 15px;

  .bg-recharge-content {
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    margin-top: -10px;
    line-height: 1.7;
    font-size: .9rem;
    border-radius: 0 0 12px 12px;

    .bg-recharge-content-item {
      padding-left: 15px;
      text-align: justify-all;
    }
  }
}

.product-drawer {
  .bg-product-info-title {
    display: flex;
    margin-bottom: 15px;

    .bg-product-info-title-price {
      flex-basis: 120px;
      box-sizing: border-box;
      position: relative;
      width: 120px;
      text-align: center;
      background-image: url("@/assets/images/beiguo/mini-coupon.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 80px;

      .bg-product-top {
        line-height: 48px;
        height: 48px;
        font-size: 1.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #CF392E;

        .bg-product-unit {
          font-size: .9rem;
        }
      }

      .bg-product-bottom {
        height: 32px;
        //垂直居中
        line-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 8px;
        font-size: .7rem;
        //禁止换行
        white-space: nowrap;
        color: #ED7659;
      }
    }

    .bg-product-info-content {
      margin-left: 10px;
      line-height: 40px;
    }
  }

  .el-card {
    --el-card-border-radius: 12px;

    margin-bottom: 15px;

    .bg-product-form-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .bg-product-form-label {
        width: 120px;
        flex-basis: 120px;
      }

      .bg-product-form-input {
        flex-basis: calc(100% - 120px);
        width: calc(100% - 120px);
        text-align: right;
      }

      & + .bg-product-form-item {
        margin-top: 15px;
        padding-top: 15px;
        border-top: var(--el-border);
      }
    }
  }
}

.bg-product-item-content-btn-left {
  .el-text {
    font-size: 1.45rem;

    &.bg-product-unit {
      font-size: .8rem;
    }
  }
}
</style>
